import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      history_changes: {
        change: 'EDIT',
        header: 'HEADER',
        remove: 'REMOVE',
        modal_window: {
          answer_no: 'MODAL_ANSWER_NO',
          answer_yes: 'MODAL_ANSWER_YES',
          remove_title: 'MODAL_REMOVE_TITLE',
          remove_question: 'MODAL_QUESTION',
        },
        history_empty: 'EMPTY_DISPLAY',
      },
    },
  }));
}
